<template>
  <v-flex >
    <v-toolbar flat class=" ">
      <v-toolbar-title class="">{{msg}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn  icon to="/pitch/settings">
        <v-icon>more_horiz</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card flat tile class="mb-4 ">
      <v-container> 
        <v-layout v-if="false"  >
          <v-flex xs12 class="mt-0 mb-3">
                <a href="help#self-assess" flat round  block color="primary" dark class="" title="Learn How to Self-Assess Your Voice Function"  >Learn to assess your ceiling pitch & voice function</a>      
          </v-flex>
        </v-layout>                
        <v-layout>
            <v-flex xs12 class="mt-2 mb-4 title" >
              What is your pitch ceiling today?  
            </v-flex>
        </v-layout>	      
        <v-layout>
          <voice-pitch></voice-pitch>
        </v-layout>            
        <v-layout v-if="false">
          <pitch-analyzer class=" "></pitch-analyzer>
        </v-layout>
        <v-layout >
          <v-flex xs4 class="mt-2 ">
            <sick></sick>
          </v-flex> 
          <v-flex xs8 class="mt-3 mb-3 text-xs-right ">
                <a href="help#self-assess" flat round  block color="primary" dark class="" title="Learn How to Self-Assess Your Voice Function"  >Learn to assess your ceiling pitch & voice function</a>      
          </v-flex>         
        </v-layout>            
      </v-container>
    </v-card>
  </v-flex>
  
</template>
<script>
import VoicePitch from '../Slider.vue'
import Sick from './Sick.vue'
import PitchAnalyzer from '../PitchAnalyzer.vue'

export default {
	data () {
		return {
			msg: 'Daily Assessment'
		}
	},
	components: {
    'voice-pitch': VoicePitch,
    'pitch-analyzer': PitchAnalyzer,
    'sick': Sick,
	}
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/home/VoicePitch.vue